import React from 'react';
import { getUserId } from '@/helpers';

import airbrake from './airbrake-client';
import ErrorDisplay from './ErrorDisplay';

type State = {
  error?: Error;
};


class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  public state: State = {};

  public static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    airbrake.notify({
      error,
      params: {
        info,
        userId: getUserId() || null,
      },
    });
  }

  public render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return <ErrorDisplay />;
  }
}

export default ErrorBoundary;
